import { Injectable, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, NavigationEnd } from '@angular/router';

import { filter, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectFilterTypeService {
  private readonly router = inject(Router);

  // Signal indicating if the current route contains 'all'
  public readonly isAllProject = signal<boolean>(false);

  // Handler for navigation end events
  private readonly _navigationEndHandler = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      tap(() => this.checkRouteForAll())
    )
  );

  constructor() {
    // Initial check
    this.checkRouteForAll();
  }

  /**
   * Checks if the current route contains 'all' segment
   */
  private checkRouteForAll(): void {
    // Parse URL segments
    const urlSegments = this.router.url.split('/');

    // Check if 'all' segment is present
    const isAll = urlSegments.includes('all');

    // Update the signal
    this.isAllProject.set(isAll);
  }
}
